import React from 'react'
import { MultiSelect } from 'components'
import { useGetBrand } from 'hooks'

type BrandProps = {
  brandState: {
    brand: string[]
    division?: string[]
    category?: string[]
    subCategory?: string[]
    reportName?: string
  }
  onChange(brand: string[], isDefaultAll?: boolean): void
  disabled?: boolean
}

export const SelectBrand = (props: BrandProps) => {
  const { brandState, onChange, disabled } = props
  const { brand, division = ['all'], category = ['all'], subCategory = ['all'], reportName } = brandState

  const { getBrandStatus, getIsBrandLoading, brandData, getBrandError } = useGetBrand({
    division,
    category,
    subCategory,
    reportName,
  })

  const isEnabled = !disabled && division.length && category.length && subCategory.length

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (getBrandStatus === 'error') {
        return getBrandError?.errorMessage ?? 'Network Error!'
      }
      if (!brand.length) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleBrandChange = (selectedBrands: string[], selectedBrandsText: string[], isDefaultAll?: boolean) => {
    onChange(selectedBrands, isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64">
      <MultiSelect
        placeholder="Select brand"
        label="Brand *"
        id="brand"
        disabled={!isEnabled}
        isLoading={getIsBrandLoading}
        value={brand}
        onChange={handleBrandChange}
        options={(brandData || []).map((item) => ({
          text: item.brand_name,
          value: item.brand_name,
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
